import {useQuery} from '@tanstack/react-query';
import {OrdersApiListOrdersRequest} from '@shipwell/corrogo-sdk';
import {ORDERS_QUERY_KEY} from '../queryKeys';
import {getOrdersList} from 'App/api/corrogo/orders';

export const useGetOrdersList = (params: OrdersApiListOrdersRequest) => {
  const {data, isLoading, isFetching, error} = useQuery({
    queryKey: [ORDERS_QUERY_KEY, params],
    queryFn: () => getOrdersList(params)
  });

  return {
    paginatedOrders: data,
    isLoadingOrders: isLoading,
    isFetchingOrders: isFetching,
    ordersError: error
  };
};
